import Reaxt from "react";
class Component extends Reaxt.Component {
}
export default Component;
//# sourceMappingURL=Component.js.map